// Latin Advanced Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const latinAdvancedItems: VocabularyItem[] = [
  // Philosophy & Abstract Concepts (1-10)
  {
    id: 'la-adv-001',
    target: 'virtus',
    english: 'virtue / courage',
    definition: 'Moral excellence or bravery',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-002',
    target: 'veritas',
    english: 'truth',
    definition: 'The quality of being true',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-003',
    target: 'sapientia',
    english: 'wisdom',
    definition: 'Deep understanding and good judgment',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-004',
    target: 'iustitia',
    english: 'justice',
    definition: 'Fair treatment according to law',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-005',
    target: 'libertas',
    english: 'liberty / freedom',
    definition: 'The state of being free',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-006',
    target: 'ratio',
    english: 'reason / method',
    definition: 'Logical thinking or a way of doing things',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-007',
    target: 'natura',
    english: 'nature',
    definition: 'The natural world or character of something',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-008',
    target: 'fatum',
    english: 'fate / destiny',
    definition: 'The predetermined course of events',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-009',
    target: 'gloria',
    english: 'glory / fame',
    definition: 'Great honor or renown',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-010',
    target: 'honor',
    english: 'honor',
    definition: 'High respect or esteem',
    partOfSpeech: 'noun'
  },

  // Government & Power (11-20)
  {
    id: 'la-adv-011',
    target: 'imperium',
    english: 'empire / command',
    definition: 'Supreme power or a realm of authority',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-012',
    target: 'senatus',
    english: 'senate',
    definition: 'A governing council of elders',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-013',
    target: 'consul',
    english: 'consul',
    definition: 'A chief magistrate of the Roman Republic',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-014',
    target: 'civis',
    english: 'citizen',
    definition: 'A member of a state with rights',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-015',
    target: 'res publica',
    english: 'republic / state',
    definition: 'The public affairs or commonwealth',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-016',
    target: 'potestas',
    english: 'power / authority',
    definition: 'The ability to control or influence',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-017',
    target: 'auctoritas',
    english: 'authority / influence',
    definition: 'Respected power or prestige',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-018',
    target: 'ius',
    english: 'right / law',
    definition: 'Legal rights or justice',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-019',
    target: 'officium',
    english: 'duty / service',
    definition: 'A moral or legal obligation',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-020',
    target: 'fides',
    english: 'faith / trust',
    definition: 'Loyalty or belief in something',
    partOfSpeech: 'noun'
  },

  // Literature & Rhetoric (21-30)
  {
    id: 'la-adv-021',
    target: 'ars',
    english: 'art / skill',
    definition: 'Creative expression or craftsmanship',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-022',
    target: 'opus',
    english: 'work / masterpiece',
    definition: 'A literary or artistic work',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-023',
    target: 'verbum',
    english: 'word',
    definition: 'A unit of language',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-024',
    target: 'sententia',
    english: 'opinion / sentence',
    definition: 'A thought or saying',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-025',
    target: 'carmen',
    english: 'song / poem',
    definition: 'A lyrical or poetic composition',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-026',
    target: 'fabula',
    english: 'story / play',
    definition: 'A narrative or dramatic work',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-027',
    target: 'oratio',
    english: 'speech / oration',
    definition: 'A formal public address',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-028',
    target: 'eloquentia',
    english: 'eloquence',
    definition: 'Fluent and persuasive speaking',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-029',
    target: 'memoria',
    english: 'memory',
    definition: 'The ability to recall past events',
    partOfSpeech: 'noun'
  },
  {
    id: 'la-adv-030',
    target: 'ingenium',
    english: 'talent / genius',
    definition: 'Natural ability or intelligence',
    partOfSpeech: 'noun'
  },

  // Advanced Adjectives (31-40)
  {
    id: 'la-adv-031',
    target: 'immortalis',
    english: 'immortal',
    definition: 'Living or lasting forever',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-032',
    target: 'divinus',
    english: 'divine',
    definition: 'Relating to or like a god',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-033',
    target: 'aeternus',
    english: 'eternal',
    definition: 'Lasting without end',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-034',
    target: 'gravis',
    english: 'heavy / serious',
    definition: 'Having weight or importance',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-035',
    target: 'clarus',
    english: 'clear / famous',
    definition: 'Bright or well-known',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-036',
    target: 'sapiens',
    english: 'wise',
    definition: 'Having good judgment and knowledge',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-037',
    target: 'dignus',
    english: 'worthy',
    definition: 'Deserving of respect or attention',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-038',
    target: 'similis',
    english: 'similar',
    definition: 'Having likeness to something else',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-039',
    target: 'difficilis',
    english: 'difficult',
    definition: 'Hard to do or understand',
    partOfSpeech: 'adjective'
  },
  {
    id: 'la-adv-040',
    target: 'perpetuus',
    english: 'perpetual / continuous',
    definition: 'Lasting forever or constantly recurring',
    partOfSpeech: 'adjective'
  },

  // Advanced Verbs (41-50)
  {
    id: 'la-adv-041',
    target: 'cogitare',
    english: 'to think / to consider',
    definition: 'To use the mind to form thoughts',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-042',
    target: 'intellegere',
    english: 'to understand',
    definition: 'To comprehend the meaning of something',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-043',
    target: 'imperare',
    english: 'to command',
    definition: 'To give orders with authority',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-044',
    target: 'vincere',
    english: 'to conquer / to win',
    definition: 'To defeat or overcome',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-045',
    target: 'defendere',
    english: 'to defend',
    definition: 'To protect from attack',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-046',
    target: 'liberare',
    english: 'to free / to liberate',
    definition: 'To set free from restraint',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-047',
    target: 'docere',
    english: 'to teach',
    definition: 'To impart knowledge to others',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-048',
    target: 'narrare',
    english: 'to tell / to narrate',
    definition: 'To give an account of events',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-049',
    target: 'memorare',
    english: 'to remember / to mention',
    definition: 'To recall or make mention of',
    partOfSpeech: 'verb'
  },
  {
    id: 'la-adv-050',
    target: 'laudare',
    english: 'to praise',
    definition: 'To express approval or admiration',
    partOfSpeech: 'verb'
  }
];
